export default __webpack_public_path__ + "static/media/mathteacher.b55d8e50.jpg";